import { Component, OnInit } from "@angular/core";
import { RegistrationService } from "src/app/registration/registration.service";
import { HttpErrorResponse } from "@angular/common/http";
import { SharedService } from "../shared.service";

@Component({
  selector: "app-privacypolicy",
  templateUrl: "./privacypolicy.component.html",
  styleUrls: ["./privacypolicy.component.scss"],
})
export class PrivacypolicyComponent implements OnInit {
  policy: any;
  constructor(
    private doctorService: RegistrationService,
    private sharedService: SharedService,
  ) {
    this.getPrivacy();
  }

  ngOnInit() {}
  getPrivacy() {
    this.doctorService.getPrivacyPolicy().subscribe(
      (res: any) => {
        this.policy = res.data[0];
      },
      (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    );
  }

  handleError(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = error.error.message;
      this.sharedService.showErrorMessage(errorMessage, "single");
    } else {
      // server-side error

      if (error.status == 422) {
        let values = [];
        for (let key in error.error.errors.messages) {
          values.push(error.error.errors.messages[key]);
        }
        this.sharedService.showMultipleErrors(values, "multi");
      } else {
        if (typeof error.error.errors == "object") {
          errorMessage = error.error.errors.messages[0];
        } else {
          errorMessage = error.error.errors;
        }
        this.sharedService.showErrorMessage(errorMessage, "single");
      }
    }
  }
}
